<template>
  <div class="sustainability-social-responsibility">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <img
          class="row-1-top-img desktop"
          src="../../assets/img/sustainability/social_responsibility/img_left.jpg"
        >
        <div class="text-group">
          <h3 class="text-accent">{{ $t('sustainability-social-responsibility-1') }}</h3>
          <h1>{{ $t('sustainability-social-responsibility-2') }}</h1>
          <!-- <h2>{{ $t('sustainability-social-responsibility-3') }}</h2> -->
          <img
            class="row-1-top-img mobile"
            src="../../assets/img/sustainability/social_responsibility/img_left.jpg"
          >
          <p v-html="$t('sustainability-social-responsibility-4')"></p>
          <p v-html="$t('sustainability-social-responsibility-5')"></p>
          <p v-html="$t('sustainability-social-responsibility-6')"></p>
           <p>
            <a
              class="link-basic"
              target="_blank"
              :href="`/files/social-responsibility/social-responsibility_${$i18n.locale}.pdf`"
            >{{ $t('sustainability-social-responsibility-7') }}</a>
          </p>
        </div>
      </div>
      <div class="img-and-btn">
        <Carousel :imgs="imgs"/>
        <!-- <img src="../../assets/img/sustainability/social_responsibility/img_right.jpg"> -->
        <!-- <div class="btn-arrow" @click="toggleScroll()">
          <span class="kcm toggle-down">C</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from './Carousel';
export default {
  data() {
    return {
      imgs: [
        require('../../assets/img/sustainability/social_responsibility/img_right.jpg'),
        require('../../assets/img/sustainability/social_responsibility/2.jpg')
      ]
    };
  },
  components: {
    Carousel
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName("btn-arrow")[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sustainability-social-responsibility {
  position: relative;
}

.mobile {
  display: none;
}
.row-1 {
  padding-bottom: 0;
}
.row-2 {
  justify-content: center;
  img {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  .row-1 {
    padding: $sidesPadding1280 0 0;
    flex-direction: column;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .img-and-text {
      width: 100%;
      .row-1-top-img {
        width: 100%;
      }
      .text-group {
        margin: 0;
        padding: 0 $sidesPadding1280;
      }
    }
    .img-and-btn {
      width: 100%;
      padding: 0;
      .carousel {
        height: 50vw;
      }
      .carousel,
      img {
        width: 100%;
        margin: 0;
      }
      .btn-arrow {
        display: none;
      }
    }
    .row-2 {
      .img-and-text {
        padding-top: 10px;
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .row-1 {
    padding: $sidesPadding600 0 0;
    .img-and-text {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }
}
</style>
